export const router = [
  {
    path: '/',
    name: 'stepchecklistlayout',
    component: () => import('/@/modules/guidancestep/pages/GuidanceStepChecklistLayout.vue'),
    children: [
      {
        path: '/step-checklist',
        name: 'step-checklist',
        component: () => import('/@/modules/guidancestep/pages/GuidanceStepChecklistPage.vue'),
        meta: { authOnly: false }
      }
    ]
  }
];
